import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-calyrafit-review';

const starPath =
  'M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z';

const buildStars = value => {
  const count = Math.max(0, Math.min(5, Number(value) || 0));
  const stars = [];
  for (let i = 0; i < count; i++) {
    stars.push(`
      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="${starPath}" fill="currentColor" />
      </svg>
    `);
  }
  return stars.join('');
};

const defaultItems = [
  {
    stars: 5,
    content:
      "<h4>Like A Workout In Disguise</h4><p>\"I was skeptical at first, but these leggings really do feel different. I can feel my legs working more when I'm walking, yet they're still comfortable enough to wear all day. It's become my favorite way to stay active.\"</p>",
    avatar: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fb528946226e5d810ad7.png',
    name: 'Olivia Smith',
    showVerified: true,
    verifiedIcon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fbb7be235051e84bbece.png',
    verifiedText: 'Verified Buyer',
  },
  {
    stars: 5,
    content:
      "<h4>Worth Every Penny</h4><p>\"I honestly didn't expect to love them this much. The quality feels great, the fit is incredibly flattering, and they're comfortable enough to wear for hours. I've already ordered another pair in a different color.\"</p>",
    avatar: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fb567df655fb2ea17d22.png',
    name: 'Emily Johnson',
    showVerified: true,
    verifiedIcon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fbb7be235051e84bbece.png',
    verifiedText: 'Verified Buyer',
  },
  {
    stars: 5,
    content:
      '<h4>More Than Just Leggings</h4><p>"These instantly became my go-to pair. They smooth everything out, stay in place all day, and make me feel so much more confident in fitted outfits. Comfortable, flattering, and surprisingly supportive."</p>',
    avatar: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fb59ff946123a8fdb1dc.png',
    name: 'Sophia Martinez',
    showVerified: true,
    verifiedIcon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1fbb7be235051e84bbece.png',
    verifiedText: 'Verified Buyer',
  },
];

const colorStarDefault = '#EF5A7B';

const itemsHtml = defaultItems
  .map(
    item => `
      <div class="swiper-slide">
        <div class="item-review" data-attribute="item-review">
          <div class="wrap-stars" data-star="${item.stars}" data-attribute="wrap-stars">
            ${buildStars(item.stars)}
          </div>
          <div class="review-content" data-attribute="review-content">
            ${item.content}
          </div>
          <div class="reviewer" data-attribute="reviewer">
            <div class="wrap-avatar">
              <img data-attribute="avatar-reviewer" src="${item.avatar}" alt="" />
            </div>
            <div class="wrap-text">
              <div class="name-reviewer" data-attribute="name-reviewer">${item.name}</div>
              <div
                class="verified-buyer"
                data-attribute="verified-buyer"
                data-show="${item.showVerified ? 'true' : 'false'}"
                style="display: ${item.showVerified ? 'flex' : 'none'};"
              >
                <div class="wrap-icon-verified">
                  <img data-attribute="icon-verified" src="${item.verifiedIcon}" alt="" />
                </div>
                <div class="text-verified" data-attribute="text-verified">${item.verifiedText}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `,
  )
  .join('');

const html = `
<div
  data-use-custom-width="false"
  data-custom-width="1204"
  class="container marquee-group"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div
    class="swiper"
    data-attribute="list-review"
    data-color-star="${colorStarDefault}"
    data-col-per-view="3"
    data-space-between="24"
    style="--color-star:${colorStarDefault}"
  >
    <div class="swiper-wrapper">
      ${itemsHtml}
    </div>
  </div>
</div>
`;

export default containerFuild(html, css);
